import { createContext, useContext } from 'react';
import Container from '@/components/complete/Container';
/**
 * @see src/exported.tsx for how to make sure this gets exported in the build!
 */
export const WidgetNameTag = 'm-claim-complete';
export type WidgetNameTagType = typeof WidgetNameTag;

/**
 * @dev: define your Widget props here, these map back to the dataset attributes
 * @example: <div data-widget="m-widget-name" data-text="Hello World" data-a-number="1" />
 */
export type WidgetNameProps = {
  id: number | undefined;
  network: number | undefined;
};

/**
 * @dev: define your default props here, these are used when no dataset attribute is provided
 */
export const defaultWidgetNameProps: WidgetNameProps = {
  id: undefined,
  network: undefined,
};

/**
 * @dev You must create a context like this for everyone's sanity.
 *      It provides a hook to all children of this widget that gives them
 *      access to the top level widget props.
 */
const WidgetNamePropsContext = createContext<WidgetNameProps>(defaultWidgetNameProps);
export function WidgetNamePropsProvider(props: {
  value: WidgetNameProps;
  children: React.ReactNode;
}) {
  return (
    <WidgetNamePropsContext.Provider value={props.value}>
      {props.children}
    </WidgetNamePropsContext.Provider>
  );
}
export const useWidgetNameProps = () => useContext(WidgetNamePropsContext);

/**
 * @dev(TODO): define your widget here, this is the component that will be rendered
 * @see src/exported.tsx for how to make sure this gets exported in the build!
 */
export default function Widget(props: WidgetNameProps) {
  return (
    <WidgetNamePropsProvider value={props}>
      <Container />
    </WidgetNamePropsProvider>
  );
}
